/**
 * DynamicUI.Edit event properties
 *
 * Ref:
 * Prompts V2: https://gotinder.atlassian.net/wiki/x/WV3bAQ
 */

import { Values } from 'Lib/typeUtils';

export const DYNAMIC_UI_EDIT = 'DynamicUI.Edit';

export const Type = {
  USER_PROMPTS: 'user_prompts',
} as const;

// Note: TypeType is confused, renaming it to EventType
export type EventType = Values<typeof Type>;

// Note: uid and st (timestamp) are provided by the common data (dataUtils/getCommonData)
export type EventData = Partial<{
  uid: string;
  st: string;
  type: EventType;
  value: string;
}>;
